import "./HeroImgStyles.css";
import React from "react";
import { Link } from "react-router-dom";

import galleria from "../assets/Dipinti/studio1.jpeg";
import cassandra from "../assets/slidemenu/cassandra.jpeg";
import ispirami from "../assets/slidemenu/ispirami.jpg";
// Immagini gi� presenti nel repo, pronte se vuoi aggiungere queste due voci:
import artemisia from "../assets/slidemenu/artemisia.jpg";
import studi from "../assets/slidemenu/studi.jpg";

// Ogni voce del menu della home. Per aggiungerne/toglierne una basta
// modificare questo elenco: il resto (layout, scroll, snap) si adatta da solo.
const slides = [
  { to: "/Ritratti", img: galleria, label: "Galleria" },
  { to: "/Cassandra", img: cassandra, label: "Cassandra Parla" },
  { to: "/Ispirami", img: ispirami, label: "Ispirami" },

  // Le due pagine qui sotto esistono gi� (rotte /Artemisia e /Studi) ma dal
  // menu non erano raggiungibili. Le immagini sono gi� importate sopra.
  // Decommenta per mostrarle nella home:
  // { to: "/Artemisia", img: artemisia, label: "Artemisia" },
  // { to: "/Studi", img: studi, label: "Studi" },
];

const HeroImg = () => {
  return (
    <div className="hero">
      {slides.map((s) => (
        <Link to={s.to} className="slide" key={s.to}>
          <img src={s.img} alt={s.label} draggable="false" />
          <div className="slide-overlay">
            <h1>{s.label}</h1>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default HeroImg;
